module.exports = __webpack_public_path__ + "static/images/auto-sync-hero.3f57bb638368e73df6831588c336f2d8.svg";